import { Card, Table, TablePaginationConfig, TableProps } from 'antd'
import { useEffect, useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import LinkAddress from 'component/link/link-address'
import { useMarketPlaceDetailContext } from 'context/marketplace/market-place-detail-provider'
import { logError } from 'utils/logger'

const MarketPlaceTransaction = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const [current, setCurrent] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const { id } = useMarketPlaceDetailContext()

  const _getMarketTransaction = async (pageIndex = 1, pageSize = 10) => {
    setLoading(true)
    if (!id) return
    try {
      const res = await AppAdmin.getActivity(pageSize, pageIndex - 1, id)
      if (res?.data.success) {
        const list = res?.data.data.map((item: any, index: number) => ({
          key: `${pageIndex}-${index}`,
          address: item.address,
          amount: item.amount,
          type: item.type,
          price: item.price,
          time: item.time_ui,
          txHash: item.txHash,
          numType: item.numType,
        }))
        setData(list)
        setTotal(res?.data.totalCount)
      }
    } catch (error) {
      setData([])
      setTotal(0)
      logError('Error fetching data: ', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    //getMarketTransaction(current, pageSize);
  }, [current, pageSize])

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current: newPage, pageSize: newPageSize } = pagination
    setCurrent(newPage || 1)
    setPageSize(newPageSize || 10)
  }

  // Define table columns
  const columns: TableProps<any>['columns'] = [
    {
      title: 'User Address',
      dataIndex: 'address',
      key: 'address',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <LinkAddress address={text} />
        </div>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (_, record) => (
        <div
          style={{
            color:
              record?.numType === 4 ? '#00D415' : record?.numType === 5 ? '#a2a0a0' : '#B43C3C',
            fontWeight: 600,
          }}
        >
          {record?.type}
        </div>
      ),
    },
    {
      title: 'Amount (MEY)',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Price (USDC)',
      dataIndex: 'price',
      key: 'price',
      render: (value) => new Intl.NumberFormat('en-US').format(value),
    },
    {
      title: 'Time',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: 'Tx Hash',
      dataIndex: 'txHash',
      key: 'txHash',
      render: (text) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <LinkAddress address={text} type="tx" />
        </div>
      ),
    },
  ]

  return (
    <Card style={{ margin: '0 auto' }}>
      <Table<any>
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={total < 11 ? false : { total, current, pageSize }}
        onChange={handleTableChange}
        scroll={{ x: 1000 }}
        bordered
      />
    </Card>
  )
}

export default MarketPlaceTransaction
